import {
  AlignmentButtons,
  ClearButtons,
  ColorButtons,
  FormatButtons,
  LevelSelect,
  LinkButtons,
  ListButtons,
  QuoteButtons,
  RichTextInputToolbar as RARichTextInputToolbar,
} from "ra-input-rich-text";

const RichTextInputToolbar = () => (
  <RARichTextInputToolbar>
    <LevelSelect />
    <FormatButtons />
    <ColorButtons />
    <AlignmentButtons />
    <ListButtons />
    <LinkButtons />
    <QuoteButtons />
    <ClearButtons />
  </RARichTextInputToolbar>
);

export default RichTextInputToolbar;
